import { createSlice } from '@reduxjs/toolkit';

const defineTheme = () => {
  const themes: string [] = ['light', 'dark'];
  const theme: string = window?.localStorage?.getItem('theme') || '';
  if (themes.includes(theme)) return theme;
  const media = window.matchMedia('(prefers-color-scheme: light)');
  return media.matches ? 'light' : 'dark';
};

interface IThemeState {
  theme: string,
}

export const initialState: IThemeState = {
  theme: defineTheme(),
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
});

export const { setTheme } = themeSlice.actions;
export default themeSlice.reducer;
